import { Badge as MantineBadge, type MantineColor } from "@mantine/core";
import type { ReactNode } from "react";

interface BadgeProps {
  children?: ReactNode;
  color?: MantineColor;
  label?: string;
  variant?: string;
}

/**
 * Badge renders the {% badge %} tag as an inline Mantine `Badge`. The body (or
 * `label`) is the text; `color` and `variant` style the pill.
 */
export const Badge = ({ children, color, label, variant }: BadgeProps) => (
  <MantineBadge color={color} variant={variant}>
    {children ?? label}
  </MantineBadge>
);
